<template>
    <div class="media-library">
        <z-filter name="Фильтр">

            <z-filter-content
                v-model="filterParams"
                :structure="structure"
                @update-params="onFilterChange"
            />
        </z-filter>

        <div class="media-library__preloader">
            <z-preloader v-if="isLoading" />
        </div>

        <results :data="items" v-if="items.length"/>

        <z-not-found class="media-library__not-found" v-else-if="!isLoading"></z-not-found>


        <z-pagination
            :data="paginationData"
            :loading="isLoading"
            :show-more="{text: 'Показать еще'}"
            @change-page="onPageChange"
            class="u-top-margin--xl-important"
        />
    </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue'

import { getMediaLibrary } from '@/api/media-library'
import { useGetData } from '@/composable/useGetData'
import { useGetter } from '@/composable/useGetter'
import { useFiltersParams } from '@/composable/useFilter';

import Results from './components/Results.vue'
import { useHandlers } from './composable/useHandlers'

const params = ref({})
const { app } = useGetter(['app'])
const isMore = ref(false)
const appData = app.value.components?.media
const { isLoading, data, fetcher } = useGetData(getMediaLibrary, params, appData)

const { onPageChange, onUpdateParams, onFilterChange } = useHandlers(params, isMore, fetcher)

const paginationData = computed(() => {
    return ({
        currentPage: data.value.nav?.current || 0,
        totalItems: data.value.nav?.count || 0,
        totalPages: data.value.nav?.total || 0,
        pageRange: 1
    })
})

const items = ref(data.value.items || [])

const rubricOption = ref(appData.filters['rubric'])

const structure = computed(() => ({
    q: {
        type: 'z-input',
        value: '',
        props: {
            title: 'Поиск',
            placeholder: 'По названию',
            size: 'm',
            icon: 'tools/magnifier',
            'icon-position': 'right',
        },
        class: 'col-default-8 col-v-tablet-12'
    },

    date: {
        type: 'z-date-picker',
        value: '',
        props: {
            title: 'По периоду',
            size: 'm',
            range: true,
            'is-filter': true
        },
        class: 'col-default-4 col-v-tablet-12'
    },
    rubric: {
        type: 'z-select',
        value: '',
        props: {
            title: 'По теме',
            size: 'm',
            placeholder: 'Все',
            options: rubricOption.value,
        },
        class: 'col-default-12 ',
    },
}))

const filterParams = useFiltersParams(structure.value);

watch(data, () => {
    rubricOption.value = data.value.filters.rubric ?? []

    if (!(data.value.items && data.value.items.length)) {
        items.value = []
        return
    }

    items.value = isMore.value ? [...items.value, ...data.value.items] : items.value = data.value.items
})
</script>

<style lang="scss">
.media-library {
    &__not-found {
        margin: var(--spacer-m) auto 0;
        width: 100%;
    }

    &__preloader {
        height: 24px;
        pointer-events: none;
        position: relative;

        .z-preloader {
            position: absolute;
            width: max-content;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            margin: 0;
            padding: 0;
        }
    }
}
</style>
